import {Component, OnDestroy, OnInit} from '@angular/core';
import {MeService} from '../../../../services/api/me.service';
import {TEST_PRIVILEGES, USER_PRIVILEGES} from '../../../../../constants/privileges';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, OnDestroy {

  showTests = false;
  showUsers = false;

  constructor(
    private meService: MeService,
  ) {
    this.meService.privileges$.subscribe(privileges => {
      this.showTests = this.meService.hasPrivilege(TEST_PRIVILEGES.READ);
      this.showUsers = this.meService.hasPrivilege(USER_PRIVILEGES.READ);
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
